import React from "react";
import { Collapse, Grid, makeStyles, Paper } from "@material-ui/core";
import {
  TableFiltersButtons,
  TableFiltersOpenButton,
} from "../../../components/Table/TableFilters";
import { TextSelector } from "../../../components/Fields/TextFields";
import jsonMap from "../../../components/Utils/jsonMap";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "hidden",
    flexDirection: "column",
  },
  textField: {
    width: "90%",
    margin: 10,
  },
}));

export default function IsgProfessionalFilters({
  options,
  tableRef,
  filterProps,
  filtersOpen,
  clearFilters,
  setFilterProps,
  setFiltersOpen,
}) {
  const classes = useStyles();

  const [tableFilters, setTableFilters] = React.useState(filterProps);
  const [collapse, setCollapse] = React.useState(filtersOpen);

  React.useEffect(() => {
    setTableFilters(filterProps);
  }, [filterProps]);

  return (
    <>
      <TableFiltersOpenButton
        collapse={collapse}
        setCollapse={setCollapse}
        setFiltersOpen={setFiltersOpen}
      />
      <Collapse in={collapse}>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={4}>
              <TextSelector
                label={"Belge Tipi"}
                value={tableFilters.documentType}
                onChangeFunc={(value) =>
                  setTableFilters({
                    ...tableFilters,
                    documentType: value.target.value,
                  })
                }
                style={classes.textField}
                options={jsonMap(false, options.documentTypes)}
              />
            </Grid>
            <Grid item xs={4}>
              <TextSelector
                label={"Aktiflik"}
                value={tableFilters.active}
                onChangeFunc={(value) =>
                  setTableFilters({
                    ...tableFilters,
                    active: value.target.value,
                  })
                }
                style={classes.textField}
                options={jsonMap(false, options.activityState)}
              />
            </Grid>
            <Grid item xs={4}>
              <TextSelector
                label={"E-İmza PIN"}
                value={tableFilters.signaturePinDefined}
                onChangeFunc={(value) =>
                  setTableFilters({
                    ...tableFilters,
                    signaturePinDefined: value.target.value,
                  })
                }
                style={classes.textField}
                options={jsonMap(false, options.definitionState)}
              />
            </Grid>
          </Grid>
          <TableFiltersButtons
            tableRef={tableRef}
            newTableFilters={tableFilters}
            setFilterProps={setFilterProps}
            clearFilters={clearFilters}
          />
        </Paper>
      </Collapse>
    </>
  );
}
